import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
export var fontFamily = 'Graphik, Helvetica, sans-serif';
export default css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  html,\n  body {\n    font-family: ", ";\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 1.25;\n  }\n"])), fontFamily);